/**
 * Runs `run` at most once per `intervalMs`; calls within the interval are
 * dropped (not deferred). Each throttled function keeps its own clock.
 */
export function throttle(run: () => void, intervalMs: number, now: () => number = Date.now): () => void {
  let lastRunAt: number | undefined;
  return (): void => {
    const time = now();
    if (lastRunAt !== undefined && time - lastRunAt < intervalMs) {
      return;
    }
    lastRunAt = time;
    run();
  };
}
